export interface StringResources {
  [key: string]: { [key: string]: string };
}

export const STRING_RESOURCES: StringResources = {
  VIEWENTRIES: {
    headerTitle: 'Capacity reports overview',
    col1Label: 'Facility name',
    col2Label: 'Report due date',
    col3Label: 'Report submitted date',
    col4Label: 'Status',
    col5Label: 'Reporter name',
  },
};
